import { LayoutStore } from 'store/layout-store';
import { LineChart } from './LineChart';
import { CandleChart } from './CandleChart';
import { useEffect, useState } from 'react';
import moment from "jalali-moment";



export const ChartArea = ({ chart, children }: any) => {
    const { dashboardChartType, dashboardChartPeriod } = LayoutStore()

    const [chartListDate, setChartListDate] = useState<any>([])
    const [chartListData, setChartListData] = useState<any>([])
    const [chartListSeries, setChartListSeries] = useState<any>([])

    useEffect(() => {
        if (chart) {
            let list_date: any = []
            let list_data: any = []
            let list_series: any = []
            let chartData = chart[dashboardChartPeriod]
            for (let i of chartData) {
                list_date.push(moment(i.date).locale('fa').format("YYYY/M/D"))
                list_data.push(i.price)
                if (dashboardChartPeriod == 'all_days') {
                    list_series.push({
                        x: moment(i.date).locale('fa').format("YYYY/M/D"),
                        y: [
                            i.firstBalanceOfDay,
                            i.maxEquityOfDay,
                            i.minEquityOfDay,
                            i.lastBalanceOfDay
                        ]
                    })
                }
                else {
                    list_series.push({
                        x: moment(i.date).locale('fa').format("YYYY/M/D"),
                        y: [
                            i.order_open_price,
                            i.order_profit,
                            i.order_take_profit,
                            i.order_close_price
                        ]
                    })
                }
            }
            setChartListDate(list_date)
            setChartListData(list_data)
            setChartListSeries(list_series)
        }
    }, [chart, dashboardChartPeriod])

    return (
        <>
            <div className="w-full flex flex-col py-4 px-3 rounded-md bg-trade-50 overflow-hidden">
                {dashboardChartType == 'line' ?
                    <LineChart
                        chart_list_date={chartListDate}
                        chart_list_data={chartListData}
                    />
                    :
                    <CandleChart
                        chart_list_series={chartListSeries}
                    />
                }
                {children}
            </div>
        </>
    )
}